import React from 'react'
import classNames from 'classnames'
import './field.sass'

class Field extends React.Component {
  state = {
    isFocus: false,
  }

  componentDidMount() {
    if (this.props.value) this.handleFocus()
  }

  handleFocus = () => {
    this.setState({ isFocus: true })
  }

  handleBlur(e) {
    if (e.target.value === '') {
      this.setState({ isFocus: false })
    }
  }

  recolorImportantMark(str) {
    const body= str.split('*')
    return <>{body}<span style={{color: "#d8353b"}}>*</span></>
  }

  render() {
    return (
      <div
        className={classNames('field', {
          'is-focus': this.state.isFocus,
          error: this.props.hasError,
        })}
      >
        <label className="field__label" htmlFor={this.props.id}>
          {this.props.label.includes('*') ? <>{this.recolorImportantMark(this.props.label)}</> : this.props.label }
        </label>
        <input
          className="field__input"
          id={this.props.name}
          name={this.props.name}
          onFocus={e => this.handleFocus(e)}
          onBlur={e => this.handleBlur(e)}
          onChange={e => this.props.onChange(this.props.name, e.currentTarget.value)}
          type={this.props.type}
          value={this.props.value}
        />
        {this.props.hasError ? <div className="field__error">{this.props.hasError}</div> : null}
      </div>
    )
  }
}

export default Field
